import { App, URLOpenListenerEvent } from '@capacitor/app'
import { PluginListenerHandleSubscription } from '@/service/subscription/PluginListenerHandleSubscription'

export async function registerToAppOpen(callback: (event: URLOpenListenerEvent) => void) {
  const maybePromise = App.addListener('appUrlOpen', callback)
  const handle = typeof (maybePromise as Promise<any>).then === 'function'
    ? await (maybePromise as Promise<any>)
    : maybePromise
  return new PluginListenerHandleSubscription([handle])
}
